<template>
  <div class="cs-video-reel" ref="csVideoIntro">
    <div class="video-reel-controls">
      <button @click="togglePlayVideo" class="play-pause-reel">
        <img v-show="!paused" :src="pause" alt="Mute Sound - Not Muted" />
        <img v-show="paused" :src="play" alt="Mute Sound - Muted" />
      </button>
      <button @click="toggleSoundVideo" class="mute-sound-reel">
        <img v-show="!muted" :src="volume" alt="Mute Sound - Not Muted" />
        <img v-show="muted" :src="volumeMute" alt="Mute Sound - Muted" />
      </button>
    </div>
    <video :src="video" disablePictureInPicture playsinline loop muted></video>
  </div>
</template>
<script>
import Heading from "@/components/Heading";
import { useTransitionComposable } from "../../composables/transition-composable";
import { ref, watch, onUnmounted } from "vue";
import { gsap } from "gsap";
import volume from "@/assets/icons/volume.png";
import volumeMute from "@/assets/icons/volume-mute.png";

import play from "@/assets/icons/play.png";
import pause from "@/assets/icons/pause.png";

const { transitionState } = useTransitionComposable();

export default {
  name: "CsVideoIntro",
  components: {
    Heading,
  },
  data() {
    return {
      muted: true,
      paused: false, //A gimmicky hack to make up for setup() not being able to talk to data()
      volume,
      volumeMute,
      play,
      pause,
    };
  },
  props: {
    video: {
      type: String,
    },
  },
  methods: {
    togglePlayVideo: function () {
      const videoPlayer = this.$refs.csVideoIntro.querySelector("video");
      if (videoPlayer.paused) {
        videoPlayer.play();
        this.paused = false;
      } else {
        videoPlayer.pause();
        this.paused = true;
      }
    },
    toggleSoundVideo: function () {
      const videoPlayer = this.$refs.csVideoIntro.querySelector("video");
      if (videoPlayer.muted) {
        videoPlayer.muted = false;
        this.muted = false;
      } else {
        videoPlayer.muted = true;
        this.muted = true;
      }
    },
  },
  setup() {
    const csVideoIntro = ref(null);
    const viewable = ref(false);
    const ctx = ref();
    watch(
      [() => transitionState.transitionComplete, csVideoIntro],
      (newValue) => {
        if (newValue[0] == true && csVideoIntro.value) {
          const el = csVideoIntro.value;
          const videoPlayer = csVideoIntro.value.querySelector("video");
          ctx.value = gsap.timeline({
            scrollTrigger: {
              trigger: el,
              start: "top 50%", // when the top of the trigger hits the top of the viewport
              onEnter: () => {
                videoPlayer.play();
              },
              once: true,
            },
          });
        }
      },
      {
        immediate: true,
      },
    );
    onUnmounted(() => {
      ctx.value.revert(); // <- Easy Cleanup!
    });
    return { csVideoIntro, viewable }; // WILL NOT WORK WITHOUT THIS
  },
};
</script>
<style lang="scss">
.cs-video-reel {
  display: block;
  width: 100%;
  margin-bottom: 4rem;
  position: relative;
  max-height: 100vh;
  overflow: hidden;

  .video-reel-controls {
    position: absolute;
    width: auto;
    background-color: white;
    bottom: 0;
    right: 2rem;
    display: flex;
    gap: 1rem;
    padding: 0.75rem 1rem;
    z-index: 2;

    & > button {
      background-color: none;
      outline: none;
      background: none;
      border: 0;
      cursor: pointer;

      img {
        width: 16px;
      }
    }
  }

  video {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
